function response(message, duration, responseEl) {
    if (!duration) duration = 3000;
    var alert = $('<div class="response alert alert-success" style="display: none"></div>');
    if (responseEl) responseEl.append(alert);
    else $('#responses').append(alert);
    $(alert).html(message).slideDown(100).delay(duration).slideUp(100).delay(300);
    setTimeout(function() { $(alert).remove(); }, duration*2);
}

function warningResponse(message, duration, responseEl) {
    if (!duration) duration = 5000;
    var alert = $('<div class="response response-warning alert alert-warning" style="display: none"></div>');
    if (responseEl) responseEl.append(alert);
    else $('#responses').append(alert);
    $(alert).html(message).slideDown(100).delay(duration).slideUp(100).delay(300);
    setTimeout(function() { $(alert).remove(); }, duration*2);
}

function errorResponse(message, duration, responseEl) {
    if (!duration) duration = 5000;
    var alert = $('<div class="response response-error alert alert-error" style="display: none"></div>');
    if (responseEl) responseEl.append(alert);
    else $('#responses').append(alert);
    $(alert).html(message).slideDown(100).delay(duration).slideUp(100).delay(300);
    setTimeout(function() { $(alert).remove(); }, duration*2);
}

